import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import { Edit, usePermissions, useDataProvider, useTranslate } from 'react-admin';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import CustomCloseButton from '@/components/global/buttons/CustomCloseButton.jsx';
import getLoadingState from '@/helpers/ui/getLoadingState.jsx';
import DeviceGroupForm from '@/components/deviceGroup/DeviceGroupForm.jsx';
import TagCategoryToolbar from '@/components/global/tags/TagCategoryToolbar';

const StyledBox = styled(Box)({
    padding: '40px 56px 56px !important',
    '& .MuiCardContent-root': {
        marginBottom: '15px !important',
    },
});

const DeviceGroupEdit = ({ handleClose, elementId }) => {
    const translate = useTranslate();
    const { permissions } = usePermissions();
    const dataProvider = useDataProvider();
    const [deviceGroup, setDevice] = useState(null);
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const loadingState = getLoadingState({ isLoading, error, data: deviceGroup, translate });

    useEffect(() => {
        if (elementId) {
            setIsLoading(true);
            dataProvider
                .getOne('device-group', { id: elementId })
                .then(({ data }) => {
                    setDevice(data);
                    setError(null);
                })
                .catch(err => {
                    console.error('Error fetching device group:', err);
                    setError(err);
                })
                .finally(() => {
                    setIsLoading(false);
                });
        }
    }, [dataProvider, elementId]);

    if (loadingState) return loadingState;

    if (isLoading || !permissions) return null;
    return (
        <Box>
            <Box className='popup-wrapper popup-wrapper-top popup-wrapper--small'>
                <Box className='popup-box popup-box--header'>
                    <Typography variant='h4'>{translate('resources.deviceGroup.labels.editDeviceGroup')}</Typography>
                    <Box>
                        <CustomCloseButton onClose={handleClose} />
                    </Box>
                </Box>
            </Box>
            <StyledBox className='popup-wrapper border-bottom'>
                <Box className='popup-box'>
                    <Edit resource='device-group' mutationMode='pessimistic' id={elementId} toolbar={false} actions={false}>
                        <DeviceGroupForm
                            toolbar={
                                <TagCategoryToolbar onCancel={handleClose} cancelLabel={translate('common.cancel')} saveLabel={translate('common.save')} />
                            }
                        />
                    </Edit>
                </Box>
            </StyledBox>
        </Box>
    );
};

DeviceGroupEdit.propTypes = {
    handleClose: PropTypes.func,
    elementId: PropTypes.string,
};

export default DeviceGroupEdit;
